(function () {
  var PROTECTION_VARIANT_ID = 57153278345594; // Protezione di Consegna
  var DISMISS_KEY = 'shippingProtectionDismissed';

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function findProtectionItem(cart) {
    return (cart.items || []).find(function (item) { return item.variant_id === PROTECTION_VARIANT_ID; });
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function syncToggleState(cart) {
    var toggle = document.getElementById('ShippingProtectionToggle');
    if (toggle) toggle.checked = !!findProtectionItem(cart);
    document.querySelectorAll('[data-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function syncLineKeys() {
    // Adding/removing the protection line item can cause the *other* cart
    // lines to be re-keyed server-side (e.g. by a bundling/discount app
    // that rewrites cart line properties on every cart mutation). If we
    // leave the DOM's line keys stale, the theme's own quantity +/- and
    // remove controls start failing with "invalid line/id parameters"
    // until the page is reloaded. We fix that WITHOUT replacing any DOM
    // nodes (which would destroy the theme's directly-bound click
    // listeners) - instead we fetch the fresh cart markup, and patch only
    // the key-bearing attributes on the existing elements in place.
    var mount = document.querySelector('[data-products]');
    if (!mount) return Promise.resolve();
    return fetch('/cart?view=ajax', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshItems = doc.querySelectorAll('.cart__item');
        freshItems.forEach(function (freshEl) {
          var freshKey = freshEl.dataset.key;
          if (!freshKey) return;
          var variantId = freshKey.split(':')[0];
          var liveEl = mount.querySelector('.cart__item[data-key^="' + variantId + ':"]');
          if (!liveEl) return;
          var oldKey = liveEl.dataset.key;
          if (oldKey === freshKey) return;

          liveEl.dataset.key = freshKey;

          var qtyInput = liveEl.querySelector('.js-qty__num');
          if (qtyInput) {
            if (qtyInput.id) qtyInput.id = 'cart_updates_' + freshKey;
            if ('id' in qtyInput.dataset) qtyInput.dataset.id = freshKey;
          }

          var label = liveEl.querySelector('label[for]');
          if (label && qtyInput && qtyInput.id) label.setAttribute('for', qtyInput.id);

          liveEl.querySelectorAll('a[href]').forEach(function (link) {
            if (link.href.indexOf('/cart/change') === -1 && link.href.indexOf('?id=' + encodeURIComponent(oldKey)) === -1 && link.href.indexOf('?id=' + oldKey) === -1) return;
            var base = link.href.split('?')[0];
            var qs = link.href.split('?')[1] || '';
            var params = new URLSearchParams(qs);
            params.set('id', freshKey);
            link.href = base + '?' + params.toString();
          });

          liveEl.querySelectorAll('[data-key], [data-id], [name="id"], input[value="' + oldKey + '"]').forEach(function (el) {
            if (el === liveEl) return;
            if (el.dataset && 'key' in el.dataset) el.dataset.key = freshKey;
            if (el.dataset && 'id' in el.dataset) el.dataset.id = freshKey;
            if (el.tagName === 'INPUT' && el.name === 'id' && el.value === oldKey) el.value = freshKey;
          });
        });
      })
      .catch(function (err) { console.error('[shipping-protection] key sync failed', err); });
  }

  function refreshTotals(cart) {
    syncToggleState(cart);
    syncLineKeys();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
    return cart;
  }

  function addProtection() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: PROTECTION_VARIANT_ID, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return getCart(); })
      .then(refreshTotals)
      .catch(function (err) { console.error('[shipping-protection] add failed', err); });
  }

  function removeProtection() {
    return getCart().then(function (cart) {
      var item = findProtectionItem(cart);
      if (!item) return cart;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      }).then(function (r) { return r.json(); });
    }).then(refreshTotals)
      .catch(function (err) { console.error('[shipping-protection] remove failed', err); });
  }

  function realItemCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (item.variant_id === PROTECTION_VARIANT_ID ? 0 : item.quantity);
    }, 0);
  }

  var ensureAutoAddedPending = null;

  function ensureAutoAdded() {
    // Guard against overlapping calls: the drawer-open watcher and the
    // add-to-cart submit listener can both fire within a few hundred ms of
    // each other. Without this guard, both would independently see "no
    // protection yet" and each call addProtection(), resulting in the
    // protection line item being added TWICE (quantity 2, double-charging
    // the customer 9,90 EUR instead of 4,95 EUR). Reusing the in-flight
    // promise makes concurrent triggers collapse into a single check.
    if (ensureAutoAddedPending) return ensureAutoAddedPending;
    ensureAutoAddedPending = getCart().then(function (cart) {
      var hasRealItems = realItemCount(cart) > 0;
      var hasProtection = !!findProtectionItem(cart);
      if (!hasRealItems) {
        if (hasProtection) return removeProtection();
        return;
      }
      if (sessionStorage.getItem(DISMISS_KEY) === '1') {
        syncToggleState(cart);
        return;
      }
      if (!hasProtection) {
        return addProtection();
      } else {
        syncToggleState(cart);
      }
    }).catch(function (err) {
      console.error('[shipping-protection] ensureAutoAdded failed', err);
    }).then(function (result) {
      ensureAutoAddedPending = null;
      return result;
    });
    return ensureAutoAddedPending;
  }

  function onToggleChange(e) {
    if (e.target.checked) {
      sessionStorage.removeItem(DISMISS_KEY);
      addProtection();
    } else {
      sessionStorage.setItem(DISMISS_KEY, '1');
      removeProtection();
    }
  }

  function isDrawerOpen() {
    return document.documentElement.className.indexOf('js-drawer-open') !== -1 ||
      document.body.className.indexOf('js-drawer-open') !== -1 ||
      document.documentElement.className.indexOf('drawer-open') !== -1;
  }

  function watchDrawer() {
    var lastState = false;
    var check = function () {
      var open = isDrawerOpen();
      if (open && !lastState) ensureAutoAdded();
      lastState = open;
    };
    new MutationObserver(check).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(check).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[href="#CartDrawer"], .js-drawer-open-cart, [data-cart-drawer-toggle], a[href="/cart"], .cart-icon-bag, .site-header__cart');
      if (trigger) setTimeout(ensureAutoAdded, 400);
    });
    check();
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchDrawer();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'ShippingProtectionToggle') onToggleChange(e);
    });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        setTimeout(ensureAutoAdded, 600);
      }
    });
  });
})();
